import { observer } from 'mobx-react-lite'
import { useToggle } from '@/hooks/state-hooks'
import { FilterControlsContainer } from '@/components/FilterControls/FilterControlsContainer'
import { PrimaryControls } from './PrimaryControls'
import { type DocumentManagementViewModel } from '@/features/documents/DocumentManagementViewModel'
import { DocumentManagementFilterViewer } from '@/features/documents/components/DocumentManagementTable/DocumentManagementFilterViewer'

export interface DocumentManagementFilterViewerContainerProps {
  vm: DocumentManagementViewModel
}

export const DocumentManagementFilterViewerContainer = observer(
  function DocumentManagementFilterViewerContainer({
    vm,
  }: DocumentManagementFilterViewerContainerProps) {
    const hasFilters = vm.searcher.filters.appliedFilterCount > 0
    const showingFilterControls = useToggle(hasFilters)

    return (
      <DocumentManagementFilterViewer
        primaryControls={
          <PrimaryControls
            isMenuDisabled={vm.selectedDocumentLongIds.size < 1}
            onDownloadSelected={vm.downloadSelectedDocuments}
            onDeleteSelected={vm.archiveSelectedDocuments}
            onChange={vm.searcher.searchText.change}
            onShowFilterControls={showingFilterControls.toggle}
            filterCount={vm.searcher.filters.appliedFilterCount}
            value={vm.searcher.searchText.value}
          />
        }
        filterControls={
          <FilterControlsContainer
            active={showingFilterControls.isEnabled}
            vm={vm.searcher.filters}
            editorTestId="job"
            testId="document-filter"
          />
        }
      />
    )
  },
)
